// Este archivo ahora actúa como un Proxy (Backward Compatibility)
// Toda la lógica pesada fue refactorizada a la carpeta ./Table para una arquitectura modular y escalable.

import DataTable from './Table/index';

export default DataTable;